import React from "react";

import * as styles from "./styles";

export const TitleHeader = ({
  title,
  textColor = "text-ll-on-surface",
}: {
  title: string | boolean;
  textColor?: string;
}) => {
  if (!title) {
    return null;
  }

  return (
    <h1 data-cy="sdk-title" className={`${styles.title} ${textColor}`}>
      {title}
    </h1>
  );
};
